import { render, staticRenderFns } from "./MasteringElements.vue?vue&type=template&id=4cfcc084&scoped=true"
import script from "./MasteringElements.vue?vue&type=script&lang=js"
export * from "./MasteringElements.vue?vue&type=script&lang=js"
import style0 from "./MasteringElements.vue?vue&type=style&index=0&id=4cfcc084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfcc084",
  null
  
)

export default component.exports